import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { useTranslations } from "next-intl";
import { MockLiveRoomPanel } from "@/components/live-mock-room-panel";
import { useAuthStore } from "@/stores/authStore";

export function TenantMockLiveRoomPage() {
  const { tenantSlug = "", sessionId = "" } = useParams<{
    tenantSlug: string;
    sessionId: string;
  }>();
  const [searchParams] = useSearchParams();
  const t = useTranslations("liveSession");
  const user = useAuthStore((state) => state.user);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const e2eMode = import.meta.env.VITE_E2E_TEST_MODE === "true";

  const roleParam = searchParams.get("role") ?? "audience";
  const lessonId = searchParams.get("lessonId") ?? "";
  const courseSlug = searchParams.get("courseSlug") ?? "";
  const isStaff = user?.role !== "student";
  const role = roleParam === "host" && isStaff ? "host" : "audience";

  if (!e2eMode) {
    return <Navigate to={`/t/${tenantSlug}/dashboard`} replace />;
  }

  if (!isAuthenticated || !user?.tenantId) {
    return <Navigate to={`/t/${tenantSlug}/login`} replace />;
  }

  if (!lessonId || !courseSlug) {
    return (
      <main className="mx-auto max-w-lg px-4 py-16" data-testid="live-mock-room-missing-context">
        <p className="text-sm text-[var(--text-muted)]">{t("mockRoomMissingContext")}</p>
      </main>
    );
  }

  return (
    <MockLiveRoomPanel
      tenantSlug={tenantSlug}
      sessionId={sessionId}
      lessonId={lessonId}
      courseSlug={courseSlug}
      role={role}
    />
  );
}
